// extracted by mini-css-extract-plugin
module.exports = {"paper":"src-components-MaterialComponents-MaterialSelectComponent-MaterialSelectListComponent-index-module__paper--1VXbb"};